import React, {useEffect, useState} from 'react';
import {Button, Modal, Row} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import lsHelpers from "../../helpers/LsHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);

const AppModal = (props) => {
    const [visible, setVisible] = useState(props.showAppModal === true);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    };

    localize();

    function toggleAppModal() {
        setVisible(!visible)
        props.toggleAppModal()
    }

    function neverShow() {
        lsHelpers.setDontShowAppModal()
        props.toggleAppModal()
    }

    function openAndroidApp(){
        window.open(`https://play.google.com/store/apps/details?id=com.openmanagerapp.open`, "_blank")
    }

    function openIOSApp(){
        window.open(`https://apps.apple.com/es/app/open-manager/id1462618811?l=${localeHelpers.currentLocale()}`, "_blank")
    }

    return (
        <Modal
            className="modal-dialog-centered modal-success"
            contentClassName="bg-gradient-success"
            isOpen={visible}
            toggle={() => toggleAppModal()}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => toggleAppModal()}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-mobile-alt"/>

                    <h4 className="mt-4 text-white">
                        {alertStrings.apps_modal_text_1}
                    </h4>

                    <p className="mt-2">
                        {alertStrings.apps_modal_text_2}
                    </p>
                </div>
            </div>
            <div className="text-center align-content-center" style={{cursor: 'pointer'}}>
                <img
                    alt="..."
                    width={130}
                    onClick={() => openIOSApp()}
                    src={localeHelpers.iosIcon()}
                />
            </div>
            <div className="text-center align-content-center mt-2 mb-2" style={{cursor: 'pointer'}}>
                <img
                    alt="..."
                    width={150}
                    onClick={() => openAndroidApp()}
                    src={localeHelpers.androidIcon()}
                />
            </div>
            <div>
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => neverShow()}
                >
                    {alertStrings.dont_show_again}
                </Button>
            </div>
        </Modal>
    );
};

export default AppModal;